
































import { getSmsTags } from '@/api/Sms/sms.api'
import ActionButton from '@/components/ActionButton.vue'
import TagsCrudDialog from '@/components/Services/Sms/TagsCrudDialog.vue'
import { TableHeader } from '@/utils/interfaces'
import { SmsTag } from '@/utils/interfaces/sms.interface'
import { tableHandler } from '@/utils/mixins/tableHandler'
import FlatCard from '~/components/FlatCard.vue'
import FlatTable from '~/components/FlatTable.vue'
import TextButton from '~/components/TextButton.vue'

export default tableHandler<SmsTag>().extend({
  components: {
    ActionButton,
    TagsCrudDialog,
    FlatCard,
    FlatTable,
    TextButton,
  },
  data() {
    return {
      headers: [
        {
          text: this.$t('name'),
          value: 'name',
        },
        {
          text: this.$t('actions'),
          value: 'actions',
        },
      ] as TableHeader[],
      getter: getSmsTags,
    }
  },
})
